import * as React from 'react';
import styled from 'styled-components';

export const LinkRow = styled.div`
  margin-bottom: 10px;
`;
